// extracted by mini-css-extract-plugin
export default {"root":"AltAlertModal_root__emYIq","message":"AltAlertModal_message__2D-tD"};